import React, { useEffect, useState } from 'react';
import {
    List,
    ListItem,
    ListItemText,
    Typography,
    Grid,
    TextField,
    Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Divider,Dialog, DialogContent, DialogTitle,DialogContentText,DialogActions
} from '@material-ui/core';
import useStyles from "../../../assets/styles/ProgramRatingStyles";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import {APP_STATUS, DEFAULT_PASS_FOR_DASHBOARD, DEFAULT_PASS_FOR_LICENSE, TOAST_TYPES} from "../../../utils/constants";
import {toast, toastWarning} from "../../../utils/utils";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {Box, Step, StepLabel, Stepper} from "@mui/material";
import {ASSESSMENT_STEPS} from "../../../utils/RatingFlowSteps";

const RatingAccessAssessment=({ options, actions, data })=>{
    const classes = useStyles();
    const { loading, isEditing } = options;
    const { inputChangeAction, saveAction, editAction,goToDqAssessmentAction, goToDqAssessAction, goToDqDashboardAction, publishAssessmentAction } = actions;
    const { app, tempValues, orgInfo, status,orgModules, ASSESSMENT_STEPS, currentStatus, } = data;
    // State for publish functionality
    const [openDialog, setOpenDialog] = useState(false);
    const [isPublished, setIsPublished] = useState(false);
    const [publishCompleted, setPublishCompleted] = useState(false);
    const activeStep = ASSESSMENT_STEPS.findIndex(step => step.status === currentStatus);
    const handleInputChange = ()=> {
        inputChangeAction();
    }

    const handleSave = ()=> {
        saveAction();
    }

    const handleEdit = ()=> {
        editAction();
    }
    const goToDqAssess = () => {
        if (!isPublished) {
            goToDqAssessAction();
        }
    }

    const goToDqDashboard = () => {
        goToDqDashboardAction();
    }

    const goToDqAssessDashboard = () => {
        goToDqAssessmentAction();
    }

    // Publish handlers
    const handlePublishClick = () => {
        setOpenDialog(true);
    };

    const handleConfirmPublish = () => {
        console.log('Assessment published');
        setPublishCompleted(true);
        publishAssessmentAction();
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        if (publishCompleted) {
            setIsPublished(true);
            setPublishCompleted(false);
        }
    };

    const handleCancelPublish = () => {
        setOpenDialog(false);
    };

    return (
        <>
            {
                status >= APP_STATUS.ASSESSMENTS_READY ?
                    <div>
                        <Box sx={{ p: 3 }}>
                            <Stepper
                                activeStep={activeStep}
                                alternativeLabel
                                sx={{
                                    '& .MuiStepLabel-root .Mui-completed': {
                                        color: '#ff6468ff'
                                    },
                                    '& .MuiStepLabel-root .Mui-active': {
                                        color: '#ff6468ff'
                                    },
                                    '& .MuiStepLabel-root .Mui-disabled': {
                                        color: '#ff6468ff',
                                        opacity: 0.5
                                    },
                                    '& .MuiStepConnector-root .MuiStepConnector-line': {
                                        borderColor: '#ff6468ff',
                                        borderTopWidth: '6px',
                                        // marginTop: '-12px'
                                    }
                                }}
                            >
                                {ASSESSMENT_STEPS.map((step) => (
                                    <Step key={step.label}>
                                        <StepLabel
                                            StepIconProps={{
                                                sx: {
                                                    '&.Mui-completed': {
                                                        color: '#ff6468ff',
                                                        fontSize: '1.7rem',
                                                        '& .MuiStepIcon-text': {
                                                            display: 'none'
                                                        }
                                                    },
                                                    '&.Mui-active': {
                                                        color: '#ff6468ff',
                                                        fontSize: '1.7rem',
                                                        '& .MuiStepIcon-text': {
                                                            display: 'none'
                                                        }
                                                    },
                                                    fontSize: '1.7rem',
                                                    '& .MuiStepIcon-text': {
                                                        display: 'none'
                                                    }
                                                }
                                            }}
                                        >
                                            {step.label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                        <Typography
                            component="h1"
                            className={classes.assessTitle}
                            variant="h6"
                        >
                            Your Created Assessment and Analytic Dashboard Tools
                        </Typography>
                        <Grid container spacing={2} style={{padding:'40px'}}>
                            {/* Box 1 */}
                            <Grid item xs={6}>
                                <Paper elevation={3} className={classes.paperStyle}>
                                    <Typography variant="h5"
                                       style={{
                                            fontSize:'35px !important',
                                            background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
                                            color: 'transparent',
                                            backgroundClip: 'text',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            fontWeight:'bold',
                                            textAlign: 'left !important'
                                       }}>
                                        Access Your Assessments
                                    </Typography>
                                    <Divider style={{ backgroundColor: '#052F44', margin:'10px 0px',marginBottom:'30px' }}/>
                                    <Typography
                                        sx={{
                                            fontSize: '16px',
                                            textAlign: 'left',
                                            mt: 3,
                                            lineHeight:'1',
                                        }}
                                    >
                                        Here’s your dedicated assessment URL that you can share directly with your users to take your curated assessment.
                                        <br/><br/>
                                        All they need to do is follow the link and sign up.
                                        <br/><br/>
                                        After signing up, they will be able to access all your assessment and their data will be populated in your analytics dashboard.

                                    </Typography>
                                    {/*<List className={classes.listItemStyle}>*/}
                                    {/*    <ListItem>*/}
                                    {/*        <ListItemText*/}
                                    {/*            primary="1. You can preview your assessment in the DQ Assessment website using the following credentials:"*/}
                                    {/*        />*/}
                                    {/*    </ListItem>*/}
                                    <Box display="flex" justifyContent="center" mt={3}>
                                        <Button
                                            onClick={goToDqAssess}
                                            variant="contained"
                                            className={classes.accessAssessmentButton}
                                            style={{
                                                width: '250px',
                                                padding: '12px 24px',
                                                fontSize: '14px'
                                            }}
                                        >
                                            YOUR ASSESSMENT LINK
                                        </Button>
                                    </Box>

                                    {/*    <ListItem >*/}
                                    {/*        <Typography variant="h6" style={{textAlign: 'left',color:'#ED6628',}}>*/}
                                    {/*            Either sign in using:</Typography>*/}
                                    {/*    </ListItem>*/}
                                    {/*    <div style={{ overflowWrap: 'break-word',}}>*/}
                                    {/*        <ul style={{textAlign: 'left', color: '#11888B',}}>*/}
                                    {/*            <li>Username: <b>{app && app.assessments_approve_info ? app.assessments_approve_info.demo_dq_assess_user : undefined}</b>*/}
                                    {/*            </li>*/}
                                    {/*            <li style={{textAlign: 'left'}}>Password: <b>{app && app.assessments_approve_info ? app.assessments_approve_info.demo_dq_assess_pass : undefined}</b>*/}
                                    {/*            </li>*/}
                                    {/*        </ul>*/}
                                    {/*    </div>*/}
                                    {/*    <ListItem>*/}
                                    {/*        <Typography variant="h6" style={{color:'#ED6628',}}>Or sign up with:*/}
                                    {/*        </Typography>*/}
                                    {/*    </ListItem>*/}

                                    {/*    <div style={{ overflowWrap: 'break-word',}}>*/}
                                    {/*        <ul style={{textAlign: 'left', marginRight: '90px', color: '#11888B',}}>*/}
                                    {/*            {*/}
                                    {/*                orgInfo &&*/}
                                    {/*                <li style={{textAlign: 'left'}}>Access*/}
                                    {/*                    Code: <b>{orgInfo.access_code}</b>*/}
                                    {/*                </li>*/}
                                    {/*            }*/}

                                    {/*        </ul>*/}
                                    {/*    </div>*/}
                                    {/*</List>*/}
                                    {/*<List className={classes.listItemStyle}>*/}
                                    {/*    <ListItem>*/}
                                    {/*        <ListItemText*/}
                                    {/*            primary={*/}
                                    {/*                <div>*/}
                                    {/*                    2. After previewing the assessment, if there is anything you would like to be updated, please reach out to {' '}*/}
                                    {/*                    <a href="mailto:research@dqforall.com">research@dqforall.com</a>.*/}
                                    {/*                </div>*/}
                                    {/*            }*/}
                                    {/*        />*/}
                                    {/*    </ListItem>*/}
                                    {/*    <ListItem>*/}
                                    {/*        <ListItemText*/}
                                    {/*            primary="3. Once the assessment is ready to be published, please click “Publish”. This step is irreversible, so please double check before proceeding."*/}
                                    {/*        />*/}
                                    {/*    </ListItem>*/}
                                    {/*    <Button*/}
                                    {/*        onClick={handlePublishClick}*/}
                                    {/*        variant="contained"*/}
                                    {/*        // className={`${classes.accessAssessmentButton} ${classes.customButton2}`}*/}
                                    {/*        disabled={isPublished}*/}
                                    {/*        className={classes.accessAssessmentButton}*/}
                                    {/*    >*/}
                                    {/*        Publish*/}
                                    {/*    </Button>*/}

                                    {/*</List>*/}

                                </Paper>
                            </Grid>

                            {/* Popup for publishing the assessment */}
                            <Dialog
                                open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                maxWidth="md"
                                fullWidth
                                PaperProps={{
                                    style: {
                                        width: '30%',
                                        height: '27%',
                                        maxWidth: 'none',
                                        textAlign: 'center',
                                    },
                                }}
                            >
                                {publishCompleted ? (
                                    <>
                                        <DialogTitle id="alert-dialog-title" className={classes.popupTitle}>
                                            Publication Complete
                                        </DialogTitle>
                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description">
                                                Your assessment is published. Thanks.
                                            </DialogContentText>
                                        </DialogContent>
                                        <div  style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '16px 24px',
                                            gap: '16px'
                                        }}>
                                            <Button
                                                onClick={handleCloseDialog}
                                                variant="contained"
                                                className={classes.cancelButton}
                                            >
                                                Close
                                            </Button>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                <DialogTitle id="alert-dialog-title" className={classes.popupTitle}>
                                    Confirm Publication
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Do you really want to publish? This will flush your testing data.
                                    </DialogContentText>
                                </DialogContent>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '16px 24px',
                                        gap: '16px'
                                    }}
                                >
                                    <Button
                                        onClick={handleCancelPublish}
                                        variant="outlined"
                                        className={classes.cancelButton}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={handleConfirmPublish}
                                        variant="contained"
                                        className={classes.confirmButton}
                                        autoFocus
                                    >
                                        Confirm
                                    </Button>
                                </div>
                                    </>
                                )}
                            </Dialog>

                            <Grid item xs={6} >
                                <Paper elevation={3} className={classes.paperStyle}>
                                    <Typography variant="h5"  style={{
                                        fontSize:'35px !important',
                                        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
                                        color: 'transparent',
                                        backgroundClip: 'text',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        fontWeight:'bold',
                                        textAlign: 'left !important'
                                    }}>Access Your Analytics Dashboard</Typography>
                                    <Divider style={{ backgroundColor: '#052F44', margin:'10px 0px' }}/>
                                    <List  className={classes.listItemStyle}>
                                        <ListItem>
                                            <ListItemText
                                                primary="1. You can access your dashboard of your aggregated users data as they take the assessments here."
                                            />
                                        </ListItem>
                                        <Button
                                            onClick={goToDqDashboard}
                                            variant="contained" className={classes.accessAssessmentButton}>
                                            Go to Dashboard
                                        </Button>
                                        <Typography variant="h6"></Typography>
                                        <div style={{ overflowWrap: 'break-word',}}>
                                            <ul style={{textAlign: 'left', color: '#11888B',}}>
                                                <li>Username: <b>{app && app.assessments_approve_info ? app.assessments_approve_info.demo_dashboard_user : undefined}</b>
                                                </li>
                                                <li style={{textAlign: 'left'}}>Password: <b>{app && app.assessments_approve_info ? app.assessments_approve_info.demo_dashboard_pass : undefined}</b>
                                                </li>
                                            </ul>
                                        </div>
                                    </List>
                                    <List  className={classes.listItemStyle}>
                                        <ListItem>
                                            <ListItemText
                                                primary="2. Upon logging in, kindly reset your password. You will also have the option to reassign the user to a different email address if needed. "
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemText
                                                primary="3. We have also included guides on how to distribute assessment accounts to your users and a dashboard overview in the downloadable guides below."
                                            />
                                        </ListItem>

                                        <Button
                                            variant="contained" className={classes.accessAssessmentButton}
                                            href="https://storage.googleapis.com/dqlab-public/docs/DQ%20Accounts%20Distribution%20Guide.pdf" target="_blank"
                                        >
                                            Account distribution Guide
                                        </Button>
                                        <Button
                                            href="https://storage.googleapis.com/dqlab-public/docs/DQ%20Dashboard%20Guide.pdf" target="_blank"
                                            variant="contained" className={classes.accessAssessmentButton}>
                                            Dashboard Guide
                                        </Button>
                                    </List>

                                </Paper>
                            </Grid>

                            {
                                app && app.assessments_approve_info && app.assessments_approve_info.enable_api &&
                                <>
                                    <Grid xs={7} md={12} item style={{marginTop:'3%'}}>
                                        <Paper elevation={3} style={{padding: '30px',
                                                   display: 'flex',
                                                   flexDirection: 'column',
                                                   height:'100%',
                                                   alignItems:'center',
                                                   textAlign:'center'}}>
                                            <Typography variant="h5"  style={{
                                                fontSize:'35px !important',
                                                background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
                                                color: 'transparent',
                                                backgroundClip: 'text',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                fontWeight:'bold',
                                                textAlign: 'center !important'
                                            }}>API Integration</Typography>
                                            <Typography>
                                                If you are integrating via API, you can find the documentation below to help with integration of the assessments into your system. If you need further technical support, please reach out to{' '}
                                                <a href="mailto:tech@dqforall.com">tech@dqforall.com</a>{' '}.
                                            </Typography>
                                            {
                                                orgInfo &&
                                                <div style={{ overflowWrap: 'break-word',}}>
                                                    <ul style={{marginTop:'20px'}}>
                                                        <li style={{textAlign: 'left'}}>App Key: <b>{orgInfo.app_key}</b></li>
                                                        <li style={{textAlign: 'left'}}>Secret Key: <b>{orgInfo.secret_key}</b></li>
                                                        <br />
                                                        <li style={{ textAlign: 'left' }}>
                                                            Callback URL:&nbsp;
                                                            {isEditing.callback_url ? (
                                                                <div>
                                                                    <TextField
                                                                        value={tempValues.callback_url}
                                                                        onChange={(e) => handleInputChange('callback_url', e)}
                                                                    />
                                                                    <Button onClick={() => handleSave('callback_url')}>Save</Button>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <b>{orgInfo?.callback_url}</b>
                                                                    <Button onClick={() => handleEdit('callback_url')}>Edit</Button>
                                                                </>
                                                            )}
                                                        </li>
                                                        <li style={{ textAlign: 'left' }}>
                                                            Callback Key:&nbsp;
                                                            {isEditing.callback_key ? (
                                                                <div>
                                                                    <TextField
                                                                        value={tempValues.callback_key}
                                                                        onChange={(e) => handleInputChange('callback_key', e)}
                                                                    />
                                                                    <Button onClick={() => handleSave('callback_key')}>Save</Button>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <b>{orgInfo?.callback_key}</b>
                                                                    <Button onClick={() => handleEdit('callback_key')}>Edit</Button>
                                                                </>
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                            }
                                            <br/>
                                            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                                                <Button
                                                    style={{marginRight: '40px'}}
                                                    component="a"
                                                    href="https://storage.googleapis.com/mydq-live-bucket/Content/Docs/DQ_App__REST_API_Implementation_Manual_v1.0.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    variant="contained" className={classes.accessAssessmentButton}>
                                                    Download API Documentation
                                                </Button>
                                            </div>
                                            <div style={{ width: '100%',marginTop:'30px' }}>
                                                <TableContainer component={Paper} style={{ width: '45%', margin: 'auto' }}>
                                                    <Table aria-label="simple table" padding="normal" size="medium">
                                                        <TableHead style={{ marginLeft:'2%' }}>
                                                            <TableRow >
                                                                <TableCell>Module Code</TableCell>
                                                                <TableCell>Module Name</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody style={{ marginLeft:'2%' }}>
                                                            {
                                                                orgModules &&
                                                                orgModules.map(row => <TableRow>
                                                                    <TableCell>{row.module_code}</TableCell>
                                                                    <TableCell>{row.module_name}</TableCell>
                                                                </TableRow>)
                                                            }


                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>


                                        </Paper>
                                    </Grid>
                                </>
                            }

                        </Grid>
                        <LoaderWithBackDrop loading={loading} />
                    </div>
            : <div className={classes.accessAssessmentContainer}>
                        <Typography component="h1" variant="h5" color="inherit" style={{ fontWeight: 'bold', textAlign:'center' }}>
                            We are now preparing your Assessment. Once ready, you will be notified via email and unlock this step to preview the Assessment and Analytics.
                        </Typography>
                    </div>
            }
        </>

    );
}
export default RatingAccessAssessment;